export const SENTRY_DSN =
  'https://b63280510cf5db77cea894c18f72e951@o4507070966005760.ingest.us.sentry.io/4510764416827392'

export const isProdEnv = () => {
  return import.meta.env.MODE === 'production' || import.meta.env.PROD
}

